import { QueryClient } from '@tanstack/react-query'

import { ApiError } from '@/services/api/client'
import { logger } from '@/utils/logger'

import { QUERY_CLIENT_CONFIG } from './index'

export const queryClient = new QueryClient({
  defaultOptions: {
    ...QUERY_CLIENT_CONFIG.defaultOptions,
    mutations: {
      onError: (error) => {
        if (error instanceof ApiError && error.status >= 500) {
          logger.error('Unhandled mutation error', error, 'unexpected')
        }
      },
    },
  },
})